import { render } from "./chartC.vue?vue&type=template&id=0724dcfb"
import script from "./chartC.vue?vue&type=script&lang=ts"
export * from "./chartC.vue?vue&type=script&lang=ts"
script.render = render

export default script